/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'HANDWASHING_SANITIZING_STATIONS',
              'WORKSTATIONS_ARE_MORE_THAN_6FT_APART',
              'PHYSICAL_BARRIERS_BETWEEN_WORKSTATIONS',
              'TEMPERATURE_CHECKS_OR_OTHER_HEALTH_SCANS_AS_WORKERS_ENTER_THE_W',
              'TRAINING_FOR_WORKERS_ON_PREVENTING_THE_SPREAD_OF_CONTAGIOUS_DIS',
              'PROVIDING_WORKERS_WITH_ADDITIONAL_PPE_E_G_MASKS_GLOVES_SPECIFIC',
              'OTHER',
              'NOT_APPLICABLE',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    what_health_and_safety_measures_does_the_fac_have_to_prevent_th: valueSchema,
  },
}
